import { StyledComponent } from 'types';

type LabelValueProps = {
  label: React.ReactNode;
  value?: React.ReactNode;
  children?: React.ReactNode;
} & StyledComponent;

export const LabelValue: React.FC<LabelValueProps> = ({ label, value, children, className }) => (
  <div
    className={`my-1 w-25 letter-spacing-067 riforma-regular d-flex flex-column justify-content-between ${className}`}
  >
    <span className='test-label text-primary opacity-60 mb-1 fs-10px fs-sm-12px'>{label}</span>
    <span className='test-value text-primary fs-12px'>{value || children}</span>
  </div>
);
